import { ComponentWithAs, Icon } from '@chakra-ui/react';
import { IIconProps } from '~/components/Icon/Icon';

export const StatsIcon: ComponentWithAs<'svg', IIconProps> = (props) => (
  <Icon
    aria-label="stats icon"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.01128 3.2546C6.0387 3.12823 7.42222 3 8.7998 3C10.1774 3 11.5609 3.12823 12.5883 3.2546C13.2826 3.33999 13.7998 3.94027 13.7998 4.66915V11.3308C13.7998 12.0597 13.2826 12.66 12.5883 12.7454C11.5609 12.8718 10.1774 13 8.7998 13C7.42222 13 6.0387 12.8718 5.01128 12.7454C4.31705 12.66 3.7998 12.0597 3.7998 11.3308V4.66915C3.7998 3.94027 4.31705 3.33999 5.01128 3.2546ZM8.7998 2C7.36621 2 5.93856 2.13301 4.8892 2.26208C3.66475 2.41269 2.7998 3.46489 2.7998 4.66915V11.3308C2.7998 12.5351 3.66475 13.5873 4.8892 13.7379C5.93856 13.867 7.36621 14 8.7998 14C10.2334 14 11.6611 13.867 12.7104 13.7379C13.9349 13.5873 14.7998 12.5351 14.7998 11.3308V4.66915C14.7998 3.46489 13.9349 2.41269 12.7104 2.26208C11.6611 2.13301 10.2334 2 8.7998 2ZM6.7998 7.5C6.7998 7.22386 6.57595 7 6.2998 7C6.02366 7 5.7998 7.22386 5.7998 7.5V11C5.7998 11.2761 6.02366 11.5 6.2998 11.5C6.57595 11.5 6.7998 11.2761 6.7998 11V7.5ZM8.7998 4.5C9.07595 4.5 9.2998 4.72386 9.2998 5V11C9.2998 11.2761 9.07595 11.5 8.7998 11.5C8.52366 11.5 8.2998 11.2761 8.2998 11V5C8.2998 4.72386 8.52366 4.5 8.7998 4.5ZM11.7998 9.5C11.7998 9.22386 11.5759 9 11.2998 9C11.0237 9 10.7998 9.22386 10.7998 9.5V11C10.7998 11.2761 11.0237 11.5 11.2998 11.5C11.5759 11.5 11.7998 11.2761 11.7998 11V9.5Z"
      fill="#1C2128"
    />
  </Icon>
);
